import _ from "underscore"

class PermissionHandler {
  constructor(permissions, plan) {
    this.permissions = permissions[plan]
    const rawList = []
    this.list = _.map(this.permissions, item => {
      if (item.enabled) rawList.push(item.name)
    })

    this.rawList = rawList
  }

  hasPermission(text) {
    return this.rawList.includes(text)
  }
}

export default PermissionHandler



// WEBPACK FOOTER //
// ./src/components/services/Permissions.js